import { SubscriptionFeatureLimitM } from './../../../../modules/shared/models/organization-subscription/subscription-feature-limit.modal';
import { FeatureSubscriptionInfoEnums } from './../../../../modules/shared/enums/feature-subscription-info.enum';
import { OrganizationSubscriptionService } from './../../../../modules/shared/services/organization-subscription.service';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { AppMainService } from '../../../../app-main.service';
import { AppMainComponent } from '../../../../app.main.component';
import { ConfigurationService } from '../../../../configurations/configurationService';
import { Status } from '../../../../models/statusEnums';
import { FormErrorHandler } from '../../../../modules/shared/helpers/form-error-handler.helper';
import { ParseHelper } from '../../../../modules/shared/parse.helper';
import { SharedChannelService } from '../../../../modules/shared/services/channel.service';
import { PermissionService } from '../../../../service/permission.service';
import { ObjectNames } from '../../../../shared/constants';
import { getSavedSearchRuleValues, getSavedSearchTreeRuleValues, savedSearchRuleNo } from '../../helpers/get-formated-rules-values.helper';
import { getSavedSearchTableColumns } from '../../helpers/get-saved-search-table-columns.helper';
import { prepareSavedSearchRuleValues } from '../../helpers/prepare-saved-search-rule-values.helper';
import { prepareSavedSearchAddEditFilter } from '../../helpers/prepare-saved-searh-filter.helper';
import { SavedSearchNS } from '../../models/saved-search.models';
import { DataTypeWithOperatorNS, SavedSearchMessage } from '../../models/saved-search.static';
import { SavedSearchesService } from '../../services/saved-searches.service';
import { AccountModuleId, LeadModuleId, OpportunityModuleId, ActivityModuleId, VendorModuleId, LocationModuleId, TaskModuleId, ProductModuleId, PurchaseOrderModuleId } from './../../../../modules/shared/constants/modules.constant';

@Component({
  selector: 'app-saved-search-add-edit',
  templateUrl: './saved-search-add-edit.component.html',
  styleUrls: ['./saved-search-add-edit.component.scss']
})
export class SavedSearchAddEditComponent implements OnInit, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() displayAddEditDialog: boolean = false;
    @Input() savedSearchEditId: number = 0;
    @Input() savedSearchViewOnly: boolean = false;
    @Input() savedSearchCopy: boolean = false;
    @Input() savedSearchDetails: SavedSearchNS.ISavedSearchOverview;
    @Output() dialogClosed = new EventEmitter<boolean>();
    @Output() loadNewList = new EventEmitter<boolean>();
    @Output() savedSearchUpdated = new EventEmitter<SavedSearchNS.UpdateSavedSearches>();

    activityModuleId = ActivityModuleId;
    taskModuleId = TaskModuleId;
    vendorModuleId = VendorModuleId;
    locationModuleId = LocationModuleId;
    selectedEditedRule: SavedSearchNS.IRuleList = null;
    selectedRuleIndex: number = -1;
    editedRuleData: SavedSearchNS.IRuleList = null;
    displayEditRule: boolean = false;
    displayParentNewRule: boolean = false;
    displayAssociateRule: boolean = false;
    showHideDefaultData:boolean=false;

    combinationRules: SavedSearchNS.ICombineRuleList[] = [];
    ruleData: SavedSearchNS.IRuleList[] = [];
    ruleList: SavedSearchNS.IRuleList[] = [];
    mainLastRule: SavedSearchNS.IRuleList[] = [];
    tempLastRuleValues = {
        selectedFilter: null,
        selectedOperator: null,
        selectedValue: null,
        selectedValue2: null,
        selectedChoice: { id: 1, name: "And" },
        selectedDataTypeWithOperator: null,
        allEnumMultiselect: [],
        treeSelectData: [],
        selectedGroupLabel: "",
        selectedGroupChildren: "",
        selectedGroup: true,
        filtersDD: [],
        filtersDDTree: []
    };

    lastRuleValues = ParseHelper.DeepCopy(this.tempLastRuleValues);
    lastAssocRuleValues = ParseHelper.DeepCopy(this.tempLastRuleValues);
    assocRuleData: SavedSearchNS.IRuleList[] = [];
    assocRuleList: SavedSearchNS.IRuleList[] = [];
    isCombinational: boolean = false;
    ruleCombination: string = "";

    accountChannelsFor: string[] = ['Estimate','Invoice','Opportunity','SalesOrder','PurchaseOrder'];
    choicesDD: SavedSearchNS.IChoice[] = [
        { id: 1, name: "And" },
        { id: 2, name: "Or" },
    ];

    //Saved Search Rules
    displaySavedSearchRule: boolean = false;
    displaySSPreviewDataList: boolean = false;
    ssPreviewDataList: any[] = []
    ssPreviewColumnList: SavedSearchNS.ISavedSearchPreviceColumnModel[] = [];

    //Dropdown list value
    users: any[] = [];
    activeUserTree: any[] = [];
    parentModules: SavedSearchNS.IObjectType[] = [];
    selectedModule: SavedSearchNS.IObjectType;
    parentModulesCopy: SavedSearchNS.IObjectType[] = [];
    parentTemplates: SavedSearchNS.ITemplate[] = [];
    selectedTemplate: SavedSearchNS.ITemplate;

    accountChannelsIsActive: any[] = [];
    accountChannels: any[] = [];
    previousAccountChannel: any;

    assoModules: SavedSearchNS.IObjectType[] = [];
    selectedAssoModule: SavedSearchNS.IObjectType;
    assoTemplates: SavedSearchNS.ITemplate[] = [];
    selectedAssoTemplate: SavedSearchNS.ITemplate;

    //Saved Search details form
    savedSearchAddViewEditHeader: string = "Add Saved Search";
    savedSearchDetailsForm: FormGroup = new FormGroup({});
    loadingSavedSearchSave: boolean = false;
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();

    subscriptionLimit: SubscriptionFeatureLimitM = null;

    constructor(
        public app: AppMainComponent,
        private confirmationService: ConfirmationService,

        private messageService: MessageService,
        private formBuilder: FormBuilder,
        private appMainService: AppMainService,
        private savedSearchesService: SavedSearchesService,
        private configService: ConfigurationService,
        private sharedChannelService: SharedChannelService,
        private permissionService: PermissionService,
        private organizationSubscriptionService: OrganizationSubscriptionService
    ) { }

    ngOnInit(): void {
        this.checkSubscriptionLimit();
        this.initSavedSearchDetailsForm();
        this.getUserTree();
        this.getModuleDetails();
        this.getAccountChannels();

        if(this.savedSearchEditId>0 && this.savedSearchDetails){
            this.setSavedSearchEditDetails();
        }

    }

    checkSubscriptionLimit(){
        this.appMainService.isShowSpinner('checkSubscriptionLimit');
        this.organizationSubscriptionService
        .getFeatureSubscriptionInfo(FeatureSubscriptionInfoEnums.SavedSearch)
        .pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.subscriptionLimit = response;
                this.appMainService.isHideSpinner('checkSubscriptionLimit');
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('checkSubscriptionLimit');
            }
        })
    }

    get subscriptionLimitReached(){
        return (!this.savedSearchDetailsForm.getRawValue().id
        && this.subscriptionLimit?.allowedLicence
        && this.subscriptionLimit?.allowedLicence<=this.subscriptionLimit?.consumedLicense)
    }

    //#region ***Saved Search Add Edit***
    initSavedSearchDetailsForm(){
        this.detailsFormErrors = {};
        this.isUnsavedData = false;
        this.savedSearchDetailsForm = this.formBuilder.group({
            id: [0],
            name: ["",{
                validators: [Validators.required, Validators.minLength(3), Validators.maxLength(255),Validators.pattern(/^(?!\s*$).+/)]
            }],
            selectedUsers: [null, [Validators.required]],
            selectedModule: [null, [Validators.required]],
            selectedChannel: [null, [Validators.required]],
            selectedAccountChannel: [null],
            description: ["",[Validators.maxLength(500)]],
            isActive: [true]
        });

        if(this.savedSearchViewOnly){
            this.savedSearchDetailsForm.disable();
        }

        this.formErrorHandler.handleErrors(this.savedSearchDetailsForm, this.detailsFormErrors, {
            name: {
            required: "Saved Search Name Is Required",
            minlength: "Enter more than 3 characters",
            maxlength: "Enter less than 255 characters"
          },
          selectedUsers: {
            required: "Select any users",
          },
          selectedModule: {
            required: "Select any module",
          },
          selectedChannel: {
            required: "Select any channel",
          },
          selectedAccountChannel: {
            required: "Select any account channel",
          },
          description: {
            maxlength: "Enter less than 500 characters"
          }
        });

        this.savedSearchDetailsForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(e => this.isUnsavedData = true);
    }

    setSavedSearchEditDetails(){
        const selectedAccountChannel = this.savedSearchDetails?.accountChannelId>0 ? {id: this.savedSearchDetails?.accountChannelId} : null;

        this.savedSearchDetailsForm.patchValue({
            id: this.savedSearchCopy ? 0 : this.savedSearchDetails.id,
            name: this.savedSearchDetails.name,
            description: this.savedSearchDetails.description,
            isActive: this.savedSearchDetails.statusId==Status.Active? true : false,
            selectedAccountChannel: selectedAccountChannel
        })

        this.previousAccountChannel = selectedAccountChannel;

        if(this.activeUserTree.length>0){
            this.setSelectedUsers();
        }

        const nameCtrl = this.savedSearchDetailsForm.get('name');
        const desCtrl = this.savedSearchDetailsForm.get('description');
        if(this.savedSearchViewOnly){
            this.savedSearchAddViewEditHeader = "View Saved Search";
            nameCtrl?.disable();
            desCtrl?.disable();
        }else{
            this.savedSearchAddViewEditHeader = this.savedSearchCopy ? 'Copy Saved Search' :"Edit Saved Search";
            nameCtrl?.enable();
            desCtrl?.enable();
        }

        if(this.parentModules.length>0){
            const selectedModule = this.parentModules.find(moduleDetails=> moduleDetails.objectId===this.savedSearchDetails.objectId);

            if(selectedModule){
                this.savedSearchDetailsForm.patchValue({
                    selectedModule: selectedModule
                },{onlySelf: true, emitEvent: false});

                this.selectParentModule();
            }
        }

        this.isCombinational = this.savedSearchDetails?.isCombinational||false;
        this.ruleCombination = this.savedSearchDetails?.ruleCombination||"";

        this.ruleData = [];
        this.savedSearchDetails.savedSearchRuleRequest.map((rule: any)=>{
                let choice = this.choicesDD.find(x => x.name == rule.operator);
                let ruleNo = rule?.ruleNo ? rule?.ruleNo : savedSearchRuleNo([...this.ruleData,...this.savedSearchDetails.savedSearchRuleRequest] as any[]);
                let eachRule: SavedSearchNS.IRuleList = {
                    id: this.savedSearchCopy ? 0 : rule.id,
                    ruleNo: ruleNo,
                    module: this.getModuleAddEdit(rule),
                    subModule: this.selectedAssoModule,
                    template: { id: rule.templateId, templateName: rule.templateName, objectId: rule.objectId, channelId: 0, channelName: '', isActive: true },
                    filter: prepareSavedSearchAddEditFilter(rule),
                    operator: { id: 1, name: rule.equation },
                    value: rule.values,
                    value2: null,
                    choice: choice,
                    isMainModule: rule.isMainModule,
                    dataTypeWithOperator: this.getOperatorByDataTypeAddEdit(rule.dataType, rule.equation),
                    valueLists: [],
                    treeValueLists: [],
                    objectId: rule.objectId,
                    objectName: rule.objectName,
                    valueRefId: rule.valueRefId,
                    groupLabel: "",
                    groupChildren: "",
                    group: false,
                    filtersDD: [],
                    filtersDDTree: [],
                    canEdit: true,
                    accountChannel: this.savedSearchDetailsForm.getRawValue().selectedAccountChannel,
                    compareWithField:  rule?.dataType === 'Enum' ? false : rule?.compareWithField || false,
                    comparisonCriteria: rule?.dataType === 'Enum' ? null : rule?.comparisonCriteria || null,
                    comparisonCriteriaLabel: rule?.comparisonCriteriaLabel||null,
                    comparisonCriteriaParentLabel: rule?.comparisonCriteriaParentLabel||null,
                    isCustomComparisonCriteria: rule.isCustomComparisonCriteria,
                    comparisonCriteriaObject: rule.comparisonCriteriaObject,
                    customAttributeObjectId: rule.customAttributeObjectId,
                    comparisonCustomAttributeObjectId: rule.comparisonCustomAttributeObjectId

                };
                //****Prepare Value
                // console.log(eachRule)
                const { value, value2 } = prepareSavedSearchRuleValues(eachRule, this.app.usersList);
                eachRule.value = value;
                eachRule.value2 = value2;
                this.ruleData.push(eachRule);
            });

            this.setCanEdit(this.ruleData);
    }

    getModuleAddEdit(rule: SavedSearchNS.SavedSearchRuleRequest): SavedSearchNS.IObjectType {
        let parentModule: SavedSearchNS.IObjectType;
        if (rule.isMainModule) {
            parentModule = (this.parentModules.find(x => x.objectId == rule.objectId)||{
                objectId: rule?.objectId,
                name: rule?.objectName
            }) as any;
        }
        else {
            parentModule = (this.assoTemplates?.find(x => x.objectId == rule.objectId)||{
                objectId: rule?.objectId,
                name: rule?.objectName
            }) as any;


        }
        return parentModule;
    }

    getOperatorByDataTypeAddEdit(dataType: string, operator: string): DataTypeWithOperatorNS.ISavedSearchDataTypeWithOperator {
        let selectedDataTypeAndOperator = DataTypeWithOperatorNS.SavedSearchDataTypeWithOperator.find(x => x.DataType == dataType && x.Operator == operator);
        return selectedDataTypeAndOperator;
    }

    saveSavedSearch(type: 'Save' | 'Preview'): void {
        if(!this.validateRuleError()){
            return;
        }

        if (this.savedSearchDetailsForm.getRawValue().id>0) {
            const updateSavedSearches = this.prepareUpdateSaveSearch(this.ruleData);
            const mainRuleExist = updateSavedSearches?.savedSearchRuleUpdateRequest?.find(x => x.isMainModule == true);
            //return
            if (mainRuleExist) {
                this.appMainService.isShowSpinner('UpdateSavedSearch');
                this.savedSearchesService.updateSavedSearch(updateSavedSearches).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
                    this.appMainService.isHideSpinner('UpdateSavedSearch');
                    this.messageService.add({ severity: SavedSearchMessage.success.toLowerCase(), summary: SavedSearchMessage.success, detail: SavedSearchMessage.updateSearchaveSuccessMsg });
                    this.loadNewList.emit(true);
                    this.savedSearchUpdated.emit(updateSavedSearches);
                    this.closeDialog();//close
                },
                    error => {
                        this.appMainService.isHideSpinner('UpdateSavedSearch');
                        this.messageService.add({ severity: SavedSearchMessage.error.toLowerCase(), summary: SavedSearchMessage.error, detail: SavedSearchMessage.updateearchaveErrorMsg });
                    });
            }
            else {
                this.messageService.add({ severity: SavedSearchMessage.warning.toLowerCase(), summary: SavedSearchMessage.warning, detail: 'At least 1 parent rule must be added.' });
            }
        }
        else {
            //Prepare saved-search object
            const newSavedSearches = this.prepareNewSaveSearch(type,this.ruleData);
            const mainRuleExist = newSavedSearches?.savedSearchRuleRequest?.find(x => x.isMainModule == true);
            // console.log(newSavedSearches);
            // return
            if (mainRuleExist) {
                this.appMainService.isShowSpinner('SaveNewSavedSearch');
                this.savedSearchesService.addSavedSearch(newSavedSearches).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
                    this.appMainService.isHideSpinner('SaveNewSavedSearch');
                    if (type == 'Preview') {
                        this.preparePreviewDataList(res);
                    }
                    else {
                        this.messageService.add({ severity: SavedSearchMessage.success.toLowerCase(), summary: SavedSearchMessage.success, detail: SavedSearchMessage.saveSearchaveSuccessMsg });
                        this.loadNewList.emit(true);
                        this.closeDialog();//close
                    }
                },
                    error => {
                        this.appMainService.isHideSpinner('SaveNewSavedSearch');
                        if(error?.error && type != 'Preview'){
                            this.messageService.add({ severity: SavedSearchMessage.error.toLowerCase(), summary: SavedSearchMessage.error, detail: error?.error });
                        }else if (type != 'Preview') {
                            this.messageService.add({ severity: SavedSearchMessage.error.toLowerCase(), summary: SavedSearchMessage.error, detail: SavedSearchMessage.saveSearchaveErrorMsg });
                        }
                    });
            }
            else {
                this.messageService.add({ severity: SavedSearchMessage.warning.toLowerCase(), summary: SavedSearchMessage.warning, detail: 'At least 1 parent rule must be added.' });
            }
        }

    }

    openPreviewSavedSearch() {
        //Call Preview
        this.previewSavedSearch('Preview', this.ruleData);
    }

    //Cancel Preview
    onSSPreviewCancel(): void {
        this.ssPreviewDataList = [];
        this.ssPreviewColumnList = [];
        this.displaySSPreviewDataList = false;
    }

    //Saved-Searche Preview
    previewSavedSearch(type: 'Save' | 'Preview', ruleData: SavedSearchNS.IRuleList[]): void {
        //Prepare saved-search object
        const newSavedSearches = this.prepareNewSaveSearch(type, ruleData);
        const mainRuleExist = newSavedSearches?.savedSearchRuleRequest?.find(x => x.isMainModule == true);
        // return
        if (mainRuleExist) {
            this.appMainService.isShowSpinner('SaveNewSavedSearch');
            this.savedSearchesService.addSavedSearch(newSavedSearches).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
                this.appMainService.isHideSpinner('SaveNewSavedSearch');
                if (type == 'Preview') {
                    this.preparePreviewDataList(res);
                }
            },
            error => {
                this.appMainService.isHideSpinner('SaveNewSavedSearch');
                if (type != 'Preview') {
                    this.messageService.add({ severity: SavedSearchMessage.error.toLowerCase(), summary: SavedSearchMessage.error, detail: SavedSearchMessage.saveSearchaveErrorMsg });
                }
            });
        }
        else {
            this.messageService.add({ severity: SavedSearchMessage.warning.toLowerCase(), summary: SavedSearchMessage.warning, detail: 'At least 1 parent rule must be added.' });
        }
    }

    //Prepare Preview Data List
    preparePreviewDataList(res: any) {
        this.displaySSPreviewDataList = true;
        // let previewColumnList: SavedSearchNS.ISavedSearchPreviceColumnModel[] = [];
        if (res?.Result) {
            this.ssPreviewDataList = res?.Result;
            this.ssPreviewColumnList = getSavedSearchTableColumns(res?.savedSearchColumnSetting ?? []) ?? [];
        }
    }

    prepareNewSaveSearch(type: 'Save' | 'Preview', ruleData: SavedSearchNS.IRuleList[]): SavedSearchNS.NewSavedSearches {

        let newSavedSearches: SavedSearchNS.NewSavedSearches = {
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            name: this.savedSearchDetailsForm.getRawValue().name,
            description: this.savedSearchDetailsForm.getRawValue().description,
            moduleId: this.savedSearchDetailsForm.getRawValue().selectedModule?.objectId,
            channelId: this.savedSearchDetailsForm.getRawValue().selectedChannel?.channelId,
            accountChannelId: this.savedSearchDetailsForm.getRawValue().selectedAccountChannel?.id||null,
            isCombinational: this.isCombinational||false,
            ruleCombination: this.ruleCombination||"",
            statusId: this.savedSearchDetailsForm.getRawValue().isActive == true ? 1 : 2,
            isPreview: type == 'Preview' ? true : false,
            previewId: 0,
            savedSearchRuleRequest: [],
            savedSearchUserPermissionRequest: [],
        };

        let savedSearchRule: SavedSearchNS.SavedSearchRuleRequest[] = [];
        let sequenceOrder = 0;
        ruleData.forEach(rule => {
            sequenceOrder += 1;
            const { values, valueRefId } = getSavedSearchRuleValues(rule);
            savedSearchRule.push(
                {
                    id: 0,
                    ruleNo: rule?.ruleNo,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    // createdBy: number;
                    // updatedBy: number;
                    // createdDate: string;
                    // updatedDate: string;
                    savedSearchId: 0,
                    objectId: rule.module.objectId ? rule.module.objectId : this.parentModulesCopy?.find(x => x.id == rule.module.id)?.objectId,
                    objectName: rule.module.name,
                    isMainModule: rule.isMainModule,
                    // criteria: rule.filter.field,
                    criteria: rule.filter.custom ? rule.filter.name : rule.filter.field?.charAt(0).toUpperCase() + rule.filter.field.slice(1),//UpperCase First Later
                    equation: rule.operator.name,
                    values: values,
                    valueRefId: valueRefId,
                    operator: rule.choice?.name,
                    isCustom: rule.filter.custom,
                    dataType: rule.filter.fieldDataType,
                    statusId: 1,
                    // status?: null,
                    // isValid: ,
                    sequenceOrder: sequenceOrder,
                    templateId: rule.template.id,
                    templateName: rule.template.templateName,
                    // validFromDate: string;
                    // validToDate: string;
                    // savedSearchRuleDetails: SavedSearchRuleDetail[];
                    labelName: null,
                    parentLabelName: null,
                    compareWithField: rule?.compareWithField||false,
                    comparisonCriteria: rule?.comparisonCriteria||null,
                    comparisonCriteriaLabel: rule?.comparisonCriteriaLabel||null,
                    comparisonCriteriaParentLabel: rule?.comparisonCriteriaParentLabel||null,
                    isCustomComparisonCriteria: rule?.isCustomComparisonCriteria||false,
                    comparisonCriteriaObject: rule?.comparisonCriteriaObject||null,
                    customAttributeObjectId: rule?.customAttributeObjectId,
                    comparisonCustomAttributeObjectId: rule?.comparisonCustomAttributeObjectId,
                    // accountChannelId: null,
                    accountChannelId: this.savedSearchDetailsForm.getRawValue().selectedModule?.name == 'Estimate' || this.savedSearchDetailsForm.getRawValue().selectedModule?.name == 'Invoice' || this.savedSearchDetailsForm.getRawValue().selectedModule?.name == 'Opportunity' || this.savedSearchDetailsForm.getRawValue().selectedModule?.name == 'SalesOrder' || this.savedSearchDetailsForm.getRawValue().selectedModule?.name == 'PurchaseOrder' ? this.savedSearchDetailsForm.getRawValue().selectedAccountChannel?.id :
                    this.savedSearchDetailsForm.getRawValue().selectedModule?.name == 'Product' ? (this.savedSearchDetailsForm.getRawValue().selectedChannel?.channelId) : null,
                }
            );
            // }
        });
        newSavedSearches.savedSearchRuleRequest = savedSearchRule;

        //UserPermissino
        let savedSearchUserPermission: SavedSearchNS.SavedSearchUserPermissionRequest[] = [];
        this.savedSearchDetailsForm.getRawValue().selectedUsers?.forEach(user => {
            savedSearchUserPermission.push({ id: 0, savedSearchId: 0, userId: user.id, userName: user.name, statusId: 1 });
        });
        newSavedSearches.savedSearchUserPermissionRequest = savedSearchUserPermission;
        return newSavedSearches;
    }

    prepareUpdateSaveSearch(ruleData: SavedSearchNS.IRuleList[]): any {
        let updateSavedSearches: SavedSearchNS.UpdateSavedSearches = {
            id: this.savedSearchDetailsForm.getRawValue().id||0,
            createdSource: this.savedSearchDetails?.createdSource||this.app.userIP,
            updatedSource: this.app.userIP,
            name: this.savedSearchDetailsForm.getRawValue().name,
            description: this.savedSearchDetailsForm.getRawValue().description,
            statusId: this.savedSearchDetailsForm.getRawValue().isActive == true ? 1 : 2,
            moduleId: this.savedSearchDetailsForm.getRawValue().selectedModule?.objectId,
            channelId: this.savedSearchDetailsForm.getRawValue().selectedChannel?.channelId,
            accountChannelId: this.savedSearchDetailsForm.getRawValue().selectedAccountChannel?.id||null,
            isCombinational: this.isCombinational||false,
            ruleCombination: this.ruleCombination||"",
            createdBy: this.savedSearchDetails?.createdBy||this.app.userId,
            createdDate: this.savedSearchDetails?.oldCreatedDate||new Date().toISOString(),
            savedSearchRuleUpdateRequest: [],
            savedSearchUserPermissionUpdateRequest: [],
        };

        let savedSearchRule: SavedSearchNS.SavedSearchRuleUpdateRequest[] = [];
        let sequenceOrder = 0;
        ruleData.forEach(rule => {
            sequenceOrder += 1;
            const { values, valueRefId } = getSavedSearchRuleValues(rule);
            savedSearchRule.push(
                {
                    id: rule.id ?? 0,
                    ruleNo: rule?.ruleNo,
                    updatedSource: this.app.userIP,
                    // createdBy: number;
                    // updatedBy: number;
                    // createdDate: string;
                    // updatedDate: string;
                    // savedSearchId: this.savedSearchesId,
                    objectId: rule.module?.objectId ?? rule.objectId,
                    objectName: rule.module?.name ?? rule.objectName,
                    isMainModule: rule.isMainModule,
                    // criteria: rule.filter.field,
                    criteria: rule.filter.custom ? rule.filter.name : rule.filter.field?.charAt(0).toUpperCase() + rule.filter.field.slice(1),//UpperCase First Later
                    equation: rule.operator.name,
                    values: values,
                    valueRefId: valueRefId,
                    operator: rule.choice?.name,
                    isCustom: rule.filter.custom,
                    dataType: rule.filter.fieldDataType,
                    statusId: 1,
                    // status?: null,
                    // isValid: ,
                    sequenceOrder: sequenceOrder,
                    templateId: rule.template.id,
                    templateName: rule.template.templateName,
                    // validFromDate: string;
                    // validToDate: string;
                    // savedSearchRuleDetails: SavedSearchRuleDetail[];
                    // labelName: null,
                    createdBy: this.app.userId,
                    createdDate: new Date().toISOString(),
                    accountChannelId: rule.accountChannel?.id ?? null,
                    compareWithField: rule?.compareWithField||false,
                    comparisonCriteria: rule?.comparisonCriteria||null,
                    comparisonCriteriaLabel: rule?.comparisonCriteriaLabel||null,
                    comparisonCriteriaParentLabel: rule?.comparisonCriteriaParentLabel||null,
                    isCustomComparisonCriteria: rule?.isCustomComparisonCriteria||false,
                    comparisonCriteriaObject: rule?.comparisonCriteriaObject||null,
                    customAttributeObjectId: rule?.customAttributeObjectId||null,
                    comparisonCustomAttributeObjectId: rule?.comparisonCustomAttributeObjectId||null
                }
            );
        });
        updateSavedSearches.savedSearchRuleUpdateRequest = savedSearchRule;

        //UserPermissino
        let savedSearchUserPermission: SavedSearchNS.SavedSearchUserPermissionUpdateRequest[] = [];
        this.savedSearchDetailsForm.getRawValue().selectedUsers?.forEach(user => {
            const userPermission = this.savedSearchDetails?.savedSearchUserPermission?.find(x => x.userId == user.id);
            savedSearchUserPermission.push({ id: userPermission?.id ?? 0, userId: user.id, userName: user.name, statusId: 1, createdBy: this.app.userId ?? 0, createdDate: new Date().toISOString(), updatedSource: this.app.userIP });
        });
        updateSavedSearches.savedSearchUserPermissionUpdateRequest = savedSearchUserPermission;
        return updateSavedSearches;
    }
    //#endregion

    //#region ***Dropdown List Loading***
    //For permission
    getUserTree(){
        this.configService.getAllUserOrgChartData(this.app.userId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                if(response){
                    this.activeUserTree = this.copyUserTree(response);
                    this.setSelectedUsers();
                }
            },
            error: (error)=>{

            }
        })
    }

    setSelectedUsers(){
        const userList = this.getFlatArrayFormChilren(this.activeUserTree)||[];
        let selectedUsr = userList.find(user => user.id == this.app.user.userId);
        if(this.savedSearchDetails){
            const selectedUsers: any[] = [];
            this.savedSearchDetails.savedSearchUserPermission.filter(u=> u?.statusId==Status.Active).map(userDetails=>{
                const selectedUser = userList.find(user=> user.id===userDetails.userId);

                if(selectedUser){
                    selectedUsers.push(selectedUser)
                }
            })

            if(selectedUsers.length==0){
                selectedUsers.push(selectedUsr);
            }
            this.savedSearchDetailsForm.patchValue({
                selectedUsers: selectedUsers||null
            })
        }else{
            const selectedUsers = [selectedUsr];
            this.savedSearchDetailsForm.patchValue({
                selectedUsers: selectedUsers||null
            })
        }
    }

    onUserSelect($event: any){
        const selectedUsers = this.savedSearchDetailsForm.getRawValue().selectedUsers;
        const exist = selectedUsers.find(x=> x.id==$event?.node?.id);

        if(exist || !$event?.node?.id){
            setTimeout(()=>{
                this.savedSearchDetailsForm.patchValue({
                    selectedUsers: selectedUsers
                },{onlySelf: true, emitEvent: false})
            })
        }

    }

    copyUserTree(originalTree: Array<object>): Array<object> {
        return originalTree.map(({ childUsers, ...data }: any) => ({
            id: data.id,
            label: `${data.name}${data?.role ? (data.name ? ' - ' : '') + data?.role : ''}`,
            name: data.name,
            selectable : data.id == this.app.userId ? false : true,
            children: this.copyUserTree(childUsers)
        }));
    }

    getFlatArrayFormChilren(members: any[]){
        let children = [];
        return members.map(m => {
          if (m.children && m.children.length) {
            children = [...children, ...m.children];
          }
          return m;
        }).concat(children.length ? this.getFlatArrayFormChilren(children) : children);
    }

    getModuleDetails() {
        this.appMainService.isShowSpinner("loadModules");
        this.savedSearchesService.getAllModules('SavedSearchModule')
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner("loadModules");
                    let resValue = [];
                    if (response) {
                        resValue = response?.map(x => ({ ...x, isMainModule: true }));
                    }
                    this.parentModules = resValue;
                    this.parentModulesCopy = JSON.parse(JSON.stringify(resValue));

                    if(this.savedSearchEditId>0 && this.savedSearchDetails){
                        const selectedModule = this.parentModules.find(moduleDetails=> moduleDetails.objectId===this.savedSearchDetails.objectId);
                        if(selectedModule){
                            this.savedSearchDetailsForm.patchValue({
                                selectedModule: selectedModule
                            },{onlySelf: true, emitEvent: false});

                            this.selectParentModule();
                        }
                    }
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("loadModules");
                    this.messageService.add({
                        severity: 'error',
                        summary: 'error',
                        detail: "Error occurred...",
                    });
                }
            });
        // this.parentModules = ParentModules;
    }

    getChildModuleDetails() {
        if (this.savedSearchDetailsForm.getRawValue().selectedModule?.name) {
            this.savedSearchesService.getSaveSearchObject('SavedSearchModule', this.savedSearchDetailsForm.getRawValue().selectedModule.name).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res: SavedSearchNS.IObjectType) => {
                this.assoModules = res.childobject;
                if (res.objectId === VendorModuleId && Array.isArray(this.assoModules)) {
                    const purchase = this.assoModules.find(child => child.objectId === PurchaseOrderModuleId);
                    if (purchase) {
                        purchase.name = 'Purchases';
                    }
                  }
                this.savedSearchDetailsForm.getRawValue().selectedModule['objectId'] = res?.objectId ?? this.savedSearchDetailsForm.getRawValue().selectedModule['objectId'];
            });
        }
    }

    //get template list by module
    getTemplateList(isMainModuleModule: boolean, data: SavedSearchNS.IObjectType, mainModule: SavedSearchNS.SavedSearchRuleRequest) {

        if (data !== null) {
            this.appMainService.isShowSpinner('getTemplateList');

            if ([AccountModuleId,LeadModuleId,OpportunityModuleId,ActivityModuleId,VendorModuleId,LocationModuleId,TaskModuleId].includes(data?.objectId)){
                const allList = [OpportunityModuleId,ActivityModuleId,VendorModuleId,LocationModuleId].includes(data?.objectId);
                this.sharedChannelService.getChannels(data?.objectId,allList).subscribe({
                    next: (response) => {
                        this.appMainService.isHideSpinner('getTemplateList');
                        let channels = response || [];

                        switch (data?.objectId) {
                            case AccountModuleId:
                                channels = this.permissionService.filterChannelsByPermissions(channels,ObjectNames.ACCOUNT);
                                break;
                            case LeadModuleId:
                                channels = this.permissionService.filterChannelsByPermissions(channels,ObjectNames.LEAD);
                                break;
                            default:
                                break;
                        }

                        const processedData = channels.map((obj) => {
                            return {
                                id: obj?.id,
                                templateName: obj?.name,
                                channelName: obj?.name,
                                channelId: obj?.id,
                                objectId: data?.objectId
                            }
                        });

                        this.assoTemplates = processedData;

                        if (isMainModuleModule){
                            this.parentTemplates = processedData;

                            if(this.savedSearchEditId>0 && this.savedSearchDetails){
                                const selectedChannel = this.parentTemplates.find(templateDetails=> templateDetails.channelId===this.savedSearchDetails.templateId);

                                if(selectedChannel){
                                    this.savedSearchDetailsForm.patchValue({
                                        selectedChannel: selectedChannel
                                    },{onlySelf: true});
                                    this.selectedAssoTemplate = selectedChannel;
                                    this.selectParentChannel();
                                }
                            }else if([ActivityModuleId,TaskModuleId,VendorModuleId,LocationModuleId].includes(this.savedSearchDetailsForm.getRawValue().selectedModule?.objectId) && this.parentTemplates?.length>0){
                                this.savedSearchDetailsForm.patchValue({
                                    selectedChannel: this.parentTemplates[0]
                                },{onlySelf: true});
                                this.selectedAssoTemplate = this.parentTemplates[0];
                                this.selectParentChannel();
                            }
                        }else{
                            this.selectedAssoTemplate = this.assoTemplates.find(x => x.id == mainModule.templateId);
                        }

                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('getTemplateList');
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.message : 'Templates are not loaded, please try again...'
                        });

                    }
                  });
            }else{
                this.configService.getConfigurationsByTemplateName(`${data.name} Template`).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(resp => {
                    this.appMainService.isHideSpinner('getTemplateList');
                    if (isMainModuleModule) {
                        if (mainModule?.templateId > 0) {
                            this.parentTemplates = resp.templates?.filter(x => x.isActive == true || x.id == mainModule?.templateId) ?? [];
                        }
                        else {
                            this.parentTemplates = resp.templates?.filter(x => x.isActive == true);
                        }
                        this.parentTemplates = this.parentTemplates.map(x => { x.objectId = resp.configuration?.objectId; return x; });

                        if(this.savedSearchEditId>0 && this.savedSearchDetails){
                            const selectedChannel = this.parentTemplates.find(templateDetails=> templateDetails.channelId===this.savedSearchDetails.templateId);

                            if(selectedChannel){
                                this.savedSearchDetailsForm.patchValue({
                                    selectedChannel: selectedChannel
                                },{onlySelf: true});

                                this.selectParentChannel();
                            }
                        }
                    } else if(![AccountModuleId,LeadModuleId,OpportunityModuleId,ActivityModuleId,TaskModuleId,VendorModuleId,LocationModuleId].includes(this.selectedModule?.objectId)) {
                        if (mainModule?.templateId > 0) {
                            this.assoTemplates = resp.templates?.filter(x => x.isActive == true || x.id == mainModule?.templateId) ?? [];
                        }
                        else {
                            this.assoTemplates = resp.templates?.filter(x => x.isActive == true);
                        }
                        this.assoTemplates = this.assoTemplates.map(x => { x.objectId = resp.configuration?.objectId; return x; });
                    }
                },
                error => {
                    this.appMainService.isHideSpinner('getTemplateList');
                });
            }
        }
    }

    getAccountChannels(): void {
        this.appMainService.isShowSpinner('getChannel');
        this.sharedChannelService.getChannels(AccountModuleId)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(
            {
                next: (response) => {
                    const channels = response || [];
                    this.accountChannels = this.permissionService.filterChannelsByPermissions(channels,ObjectNames.ACCOUNT);
                    this.accountChannelsIsActive = this.accountChannels;
                    this.appMainService.isHideSpinner('getChannel');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getChannel');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
                    });

                },
                complete: () => {
                    //this.getChannelStage(this.selectedChannelN?.id);
                },
            });
    }

    //#endregion

    //#region ***Dropdown Event Methods***
    onChangeParentModule(){
        this.parentTemplates = null;
        this.ruleData = [];
        this.selectParentModule(true);
    }

    selectParentModule(clearAccountChannel: boolean = false){
        this.selectedModule = this.savedSearchDetailsForm.getRawValue().selectedModule;
        this.savedSearchDetailsForm.patchValue({
            selectedChannel: null,
            selectedAccountChannel: clearAccountChannel ? null : this.savedSearchDetailsForm.getRawValue().selectedAccountChannel
        },{onlySelf: true});
        this.selectedAssoModule = null;
        this.selectedAssoTemplate = null;
        this.getTemplateList(true, this.selectedModule, null);
        this.getChildModuleDetails();
    }

    onChangeParentChannel(){
        if(this.ruleData.length>0){
            this.confirmationService.confirm({
                header: 'Delete Confirmation',
                message: 'Do you want to delete the Rules?',
                icon: 'pi pi-info-circle',
                accept: () => {
                    this.ruleData = [];
                    this.selectParentChannel();
                },
                reject: () => {
                    this.savedSearchDetailsForm.controls['selectedChannel'].patchValue(
                        this.selectedTemplate
                    );
                }
            });
        }else{
            this.selectParentChannel();
        }
    }

    selectParentChannel(){
        this.selectedTemplate = this.savedSearchDetailsForm.getRawValue().selectedChannel;
        this.selectedAssoTemplate = this.savedSearchDetailsForm.getRawValue().selectedChannel;
        // this.getTemplateFields();
    }

    selectAssociateModule(){
        // this.getTemplateList(false, this.selectedAssoModule, null);
        this.ruleData.length>0 ? this.showHideDefaultData=true : this.showHideDefaultData=false
    }

    selectAssociateChannel(){
        // this.getFieldListByTemplate(false, selectedAssoTemplate, null)
    }
    //#endregion

    //#region ***Rules Add Edit***

    newParentRule() {
        this.ruleData.length>0 ? this.showHideDefaultData=true : this.showHideDefaultData=false
        this.lastRuleValues = {
            ...this.lastRuleValues,
            selectedFilter: null,
            selectedOperator: null,
            selectedValue: null,
            selectedValue2: null,
            selectedChoice:  this.ruleData.length>1 ? this.ruleData[1].choice : { id: 1, name: "And" },
            compareWithField: false,
            comparisonCriteria: null,
            comparisonCriteriaLabel: null,
            comparisonCriteriaParentLabel: null,
            isCustomComparisonCriteria: false,
            comparisonCriteriaObject: null,
            customAttributeObjectId: null,
            comparisonCustomAttributeObjectId: null
        };
        this.ruleList = [];
        this.displayParentNewRule = true;
    }

    addAssociateModule() {
        this.showHideDefaultData=false;
        this.lastAssocRuleValues = {
            ...this.lastAssocRuleValues,
            selectedFilter: null,
            selectedOperator: null,
            selectedValue: null,
            selectedValue2: null,
            selectedChoice: this.ruleData.length>1 ? this.ruleData[1].choice : { id: 1, name: "And" },
            compareWithField: false,
            comparisonCriteria: null,
            comparisonCriteriaLabel: null,
            comparisonCriteriaParentLabel: null,
            isCustomComparisonCriteria: false,
            comparisonCriteriaObject: null,
            customAttributeObjectId: null,
            comparisonCustomAttributeObjectId: null
        };
        this.selectedAssoModule = null;
        this.assocRuleList = [];
        this.displayAssociateRule = true;
    }

    get parentRulesLength(){
        return this.ruleData.filter(rule=> rule.isMainModule)?.length;
    }

    get associateRulesLength(){
        return this.ruleData.filter(rule=> !rule.isMainModule)?.length;
    }

    cancelParentRuleDialog(){
        this.ruleList = [];
        this.assocRuleList = [];
        this.selectedAssoModule = null;
        this.displayParentNewRule = false;
        this.displayAssociateRule = false;
    }

    editRule(ruleDetails: {rule: SavedSearchNS.IRuleList, index: number}){
        if(ruleDetails.rule?.module?.name=='Transactions' && ruleDetails?.rule?.filter?.field==='trans_TransactionType'){
            this.confirmationService.confirm({
                header: 'Delete Confirmation',
                message: 'Transaction Dependent Rules will be deleted while editing, do you want to continue?',
                icon: 'pi pi-info-circle',
                accept: () => {
               this.deleteEditRuleForParent('edit')
               this.selectedEditedRule = ruleDetails.rule;
               this.selectedRuleIndex = ruleDetails.index;
               this.editedRuleData = null;
               this.displayEditRule = true;
                }
            });
            
        }
        else{
            this.selectedEditedRule = ruleDetails.rule;
            this.selectedRuleIndex = ruleDetails.index;
            this.editedRuleData = null;
            this.displayEditRule = true;
        }

    }

    removeRule(ruleDetails: {rule: any, index: number}){
        if(ruleDetails.rule.module.name=='Transactions' && ruleDetails.rule.filter.field==='trans_TransactionType'){
           this.confirmationService.confirm({
            header: 'Delete Confirmation',
            message: 'Do you also want to delete the Transaction Dependent Rules?',
            icon: 'pi pi-info-circle',
            accept: () => {
           this.deleteEditRuleForParent('delete')
            }
        });
        }
        else
        this.ruleData.splice(ruleDetails.index,1);
        this.setCanEdit(this.ruleData);
        this.ruleData = this.ruleData;
    }

    deleteEditRuleForParent(deletEditRule:string){
        if(deletEditRule=='delete'){
            for(let i=0; i<this.ruleData.length;i++){
                if(this.ruleData[i]?.module?.name=='Transactions'){
                    this.ruleData.splice(i,1)
                    i=i-1
                }
            }

        }
        else{
            for(let i=0; i<this.ruleData.length;i++){
                if(this.ruleData[i]?.module?.name=='Transactions' && this.ruleData[i]?.filter?.field !=='trans_TransactionType'){
                    this.ruleData.splice(i,1)
                    i=i-1
                }
            }
        }
    }

    saveRuleCombination(data: {isCombinational: boolean, ruleCombination: string}){
        this.isCombinational = data.isCombinational;
        this.ruleCombination = data.ruleCombination;
    }

    cancelEditRule(){
        this.displayEditRule = false;
        this.selectedEditedRule = null;
    }

    validateRuleError(){
        const invalidField = document.querySelector('.saved-search-rule-error');
        const classList = invalidField?.classList ? Array.from(invalidField.classList) : [];
        let valid: boolean = true;
        if(classList?.length>0){
            valid = false;
        }

        return valid;
    }

    //Add To RuleData List
    saveRule(isMainModule: boolean) {
        if(!this.validateRuleError()){
            return;
        }

        let lastSelectedChoice: any = { id: 1, name: "And" };

        //Parent Rules
        let parentRule = this.ruleData.filter(ele => ele.isMainModule == true);
        //Associate Rules
        let associateRule = this.ruleData.filter(ele => ele.isMainModule == false);
        if (this.ruleList.length > 0) {
            for (let s of this.ruleList) {
                if(s?.filter?.parent || s?.filter?.children){
                    s.filter.parent = null;
                    s.filter.children = null
                }
                s.filtersDDTree = [];
                s.ruleNo = !s?.ruleNo ? savedSearchRuleNo([...parentRule,...associateRule]) : s.ruleNo;
                parentRule.push(s);
            }
            lastSelectedChoice = this.ruleList[(this.ruleList.length-1)].choice||lastSelectedChoice;
        }

        if (this.assocRuleList.length > 0) {
            for (let s of this.assocRuleList) {
                if(s?.filter?.parent || s?.filter?.children){
                    s.filter.parent = null;
                    s.filter.children = null
                }
                s.filtersDDTree = [];
                s.ruleNo = !s?.ruleNo ? savedSearchRuleNo([...parentRule,...associateRule]) : s.ruleNo;
                associateRule.push(s);
            }
            lastSelectedChoice = this.assocRuleList[(this.assocRuleList.length-1)].choice||lastSelectedChoice;
        }

        const parentRuleNo = savedSearchRuleNo([...parentRule,...associateRule]);
        const lastMainRule = this.setLastRuleValue(this.lastRuleValues,true,parentRuleNo);

        if(lastMainRule && isMainModule){
            parentRule.push(lastMainRule);
            lastSelectedChoice = lastMainRule.choice||lastSelectedChoice;
        }
        const associtateRuleNo = savedSearchRuleNo([...parentRule,...associateRule]);
        const lastAssocRule = this.setLastRuleValue(this.lastAssocRuleValues,false,associtateRuleNo);

        if(lastAssocRule && !isMainModule){
            associateRule.push(lastAssocRule);
            lastSelectedChoice = lastAssocRule.choice||lastSelectedChoice;
        }

        // associateRule = associateRule?.sort((a, b) => b.subModule?.name > a.subModule?.name ? -1 : 1) ?? associateRule;
        this.ruleData = [];
        for (let a of parentRule) {
            a.choice = a.choice ?? { id: 1, name: "And" };
            this.ruleData.push(a);
        }
        for (let b of associateRule) {
            b.choice = b.choice ?? { id: 1, name: "And" };
            this.ruleData.push(b);
        }

        for (let rule of this.ruleData) {
            // rule.choice = lastSelectedChoice;
            rule = getSavedSearchTreeRuleValues(rule);
        }

        if (this.ruleData.length > 0) {
            this.ruleData[0].choice = null;
        }

        this.ruleList = [];
        this.assocRuleList = [];
        //Country,State,City rule edit enable/disable
        this.setCanEdit(this.ruleData);
        this.displayParentNewRule = false;
        this.displayAssociateRule = false;
    }

    updateEditedRule(){
        if(!this.validateRuleError()){
            return;
        }

        if(this.ruleData.length>this.selectedRuleIndex){
            const editedRuleData = this.selectedEditedRule?.isMainModule ? this.setEditedRuleValue(this.lastRuleValues) : this.setEditedRuleValue(this.lastAssocRuleValues);
            if(editedRuleData){
                this.ruleData[this.selectedRuleIndex] = editedRuleData;
                this.editedRuleData = editedRuleData;

                // this.ruleData.map(rule=>{
                //     rule.choice = this.ruleData[this.selectedRuleIndex].choice
                // })

                this.ruleData[0].choice = null;
                this.setCanEdit(this.ruleData);
                this.displayEditRule = false;
            }
        }
    }

    updateRuleChoice(data: {ruleIndex: number, choice: SavedSearchNS.IChoice}){
        this.ruleData[data.ruleIndex].choice = data.choice;
    }

    setLastRuleValue(lastRuleValue: any, isMainModule, ruleNo: string){
        if (lastRuleValue.selectedFilter && ((lastRuleValue.selectedValue || lastRuleValue.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value') || (['Money','Number','Decimal'].includes(lastRuleValue.selectedFilter?.fieldDataType) && lastRuleValue.selectedValue!==null) ||
                (lastRuleValue.selectedFilter?.fieldDataType == 'DateTime' && lastRuleValue.selectedDataTypeWithOperator?.Operator == 'Is' && lastRuleValue.selectedValue2))) {
            let eachRule: SavedSearchNS.IRuleList = {
                id: 0,
                ruleNo: ruleNo,
                module: isMainModule == true ? this.savedSearchDetailsForm.getRawValue().selectedModule : this.selectedAssoModule,
                subModule: this.selectedAssoModule,
                template: isMainModule == true ? this.savedSearchDetailsForm.getRawValue().selectedChannel : this.selectedAssoTemplate,
                filter: lastRuleValue.selectedFilter,
                operator: lastRuleValue.selectedOperator,
                value: lastRuleValue.selectedValue,
                value2: lastRuleValue.selectedValue2,
                choice: lastRuleValue.selectedChoice,
                isMainModule: isMainModule,
                dataTypeWithOperator: lastRuleValue.selectedDataTypeWithOperator,
                valueLists: lastRuleValue.allEnumMultiselect,
                treeValueLists: lastRuleValue.treeSelectData,
                objectId: isMainModule == true ? this.savedSearchDetailsForm.getRawValue().selectedModule?.objectId : this.selectedAssoModule?.objectId,
                objectName: isMainModule == true ? this.savedSearchDetailsForm.getRawValue().selectedModule?.name : this.selectedAssoModule?.name,
                valueRefId: [],
                groupLabel: lastRuleValue.selectedGroupLabel,
                groupChildren: lastRuleValue.selectedGroupChildren,
                group: lastRuleValue.selectedGroup,
                filtersDD: lastRuleValue.filtersDD,
                canEdit: true,
                accountChannel: this.savedSearchDetailsForm.getRawValue().selectedAccountChannel,
                compareWithField: lastRuleValue?.compareWithField||false,
                comparisonCriteria: lastRuleValue?.comparisonCriteria||null,
                comparisonCriteriaLabel: lastRuleValue?.comparisonCriteriaLabel||null,
                comparisonCriteriaParentLabel: lastRuleValue?.comparisonCriteriaParentLabel||null,
                isCustomComparisonCriteria: lastRuleValue?.isCustomComparisonCriteria||false,
                comparisonCriteriaObject:  isMainModule == true ? this.savedSearchDetailsForm.getRawValue().selectedModule?.name : this.selectedAssoModule?.name,
                customAttributeObjectId: lastRuleValue?.customAttributeObjectId||null,
                comparisonCustomAttributeObjectId: lastRuleValue?.comparisonCustomAttributeObjectId||null,
            }

            if(eachRule?.filter?.parent || eachRule?.filter?.children){
                eachRule.filter.parent = null;
                eachRule.filter.children = null
            }

            return eachRule;
        }

        return null;
    }

    setEditedRuleValue(lastRuleValue: any){
        if (lastRuleValue.selectedFilter && ((lastRuleValue.selectedValue || lastRuleValue.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value') || (['Money','Number','Decimal'].includes(lastRuleValue.selectedFilter?.fieldDataType) && lastRuleValue.selectedValue!==null) ||
                (lastRuleValue.selectedFilter?.fieldDataType == 'DateTime' && lastRuleValue.selectedDataTypeWithOperator?.Operator == 'Is' && lastRuleValue.selectedValue2))) {
            let eachRule: SavedSearchNS.IRuleList = {
                ...this.selectedEditedRule,
                filter: lastRuleValue.selectedFilter,
                operator: lastRuleValue.selectedOperator,
                value: lastRuleValue.selectedValue,
                value2: lastRuleValue.selectedValue2,
                choice: lastRuleValue.selectedChoice,
                dataTypeWithOperator: lastRuleValue.selectedDataTypeWithOperator,
                valueLists: lastRuleValue.allEnumMultiselect,
                treeValueLists: lastRuleValue.treeSelectData,
                valueRefId: [],
                groupLabel: lastRuleValue.selectedGroupLabel,
                groupChildren: lastRuleValue.selectedGroupChildren,
                group: lastRuleValue.selectedGroup,
                filtersDD: lastRuleValue.filtersDD,
                compareWithField: lastRuleValue?.compareWithField||false,
                comparisonCriteria: lastRuleValue?.comparisonCriteria||null,
                comparisonCriteriaLabel: lastRuleValue?.comparisonCriteriaLabel||null,
                comparisonCriteriaParentLabel: lastRuleValue?.comparisonCriteriaParentLabel||null,
                isCustomComparisonCriteria: lastRuleValue?.isCustomComparisonCriteria,
                customAttributeObjectId: lastRuleValue?.customAttributeObjectId||null,
                comparisonCustomAttributeObjectId: lastRuleValue?.comparisonCustomAttributeObjectId||null,
            }
            eachRule = getSavedSearchTreeRuleValues(eachRule);
            if(eachRule?.filter?.parent || eachRule?.filter?.children){
                eachRule.filter.parent = null;
                eachRule.filter.children = null
            }

            return eachRule;
        }

        return null;
    }

    //Country,State,City rule edit enable/disable
    setCanEdit(ruleData: SavedSearchNS.IRuleList[]) {
        //Set Rule Edit Enable/Disable
        for (let rule of ruleData) {
            rule.canEdit = this.canRuleEdit(rule.filter,ruleData);
        }
        //Remove first choice
        if (ruleData?.length > 0) {
            ruleData[0].choice = null;
        }
    }

    canRuleEdit(filter: SavedSearchNS.IField, ruleData: SavedSearchNS.IRuleList[]): boolean {
        let canRuleEdit = true;
        if (filter &&
            (filter?.field?.toLowerCase() == "country" ||
                filter?.field?.toLowerCase() == "state" ||
                filter?.field?.toLowerCase() == "city")) {

            const country = ruleData.find(x => x.filter.field?.toLowerCase() == "country");
            const state = ruleData.find(x => x.filter.field?.toLowerCase() == "state");
            const city = ruleData.find(x => x.filter.field?.toLowerCase() == "city");
            //Country
            if (filter?.field?.toLowerCase() == "country") {
                if (state) {
                    canRuleEdit = false;
                }
            }
            //State
            else if (filter?.field?.toLowerCase() == "state") {
                if (city) {
                    canRuleEdit = false;
                }
            }
            //City
            else if (filter?.field?.toLowerCase() == "city") {
                canRuleEdit = true;
            }

        }

        if (filter && ['trans_location_country','trans_location_state'].includes(filter?.field?.toLowerCase())) {
            const trans_location_state = ruleData.find(x => x.filter.field?.toLowerCase() == "trans_location_state");
            const trans_location_city = ruleData.find(x => x.filter.field?.toLowerCase() == "trans_location_city");

            if ((filter?.field?.toLowerCase() == "trans_location_country" && trans_location_state)
                ||(filter?.field?.toLowerCase() == "trans_location_state" && trans_location_city)) {
                canRuleEdit = false;
            }
        }

        if (filter && ['opportunity_country','opportunity_state'].includes(filter?.field?.toLowerCase())) {
            const opportunity_state = ruleData.find(x => x.filter.field?.toLowerCase() == "opportunity_state");
            const opportunity_city = ruleData.find(x => x.filter.field?.toLowerCase() == "opportunity_city");

            if ((filter?.field?.toLowerCase() == "opportunity_country" && opportunity_state)
                ||(filter?.field?.toLowerCase() == "opportunity_state" && opportunity_city)) {
                canRuleEdit = false;
            }
        }

        if (filter && (filter?.field?.toLowerCase() == "associatedmodulename" || filter?.field?.toLowerCase() == "associatedchannelname")) {

            const associatedchannelname = ruleData.find(x => x.filter.field?.toLowerCase() == "associatedchannelname");
            const associationname = ruleData.find(x => x.filter.field?.toLowerCase() == "associationname");

            if (filter?.field?.toLowerCase() == "associatedmodulename") {
                canRuleEdit = !associatedchannelname;
            }
            else if (filter?.field?.toLowerCase() == "associatedchannelname") {
                canRuleEdit = !associationname;
            }
        }

        if (filter && (filter?.field?.toLowerCase() == "type" || filter?.field?.toLowerCase() == "logtype")) {

            const logtype = ruleData.find(x => x.filter.field?.toLowerCase() == "logtype");
            const logsubtype = ruleData.find(x => x.filter.field?.toLowerCase() == "logsubtype");

            if (filter?.field?.toLowerCase() == "type") {
                canRuleEdit = !logtype;
            }
            else if (filter?.field?.toLowerCase() == "logtype") {
                canRuleEdit = !logsubtype;
            }
        }

        // const transactionType = ruleData.find(x => x.filter.field?.toLowerCase() == "trans_transactiontype");
        // if(transactionType && filter && filter.field?.toLowerCase() == "trans_transactiontype"){
        //     const tansactionFields = ruleData.find(x => x?.objectId == transactionType?.objectId && x.filter.field?.toLowerCase() != "trans_transactiontype");
        //     canRuleEdit = !tansactionFields;
        // }

        return canRuleEdit;
    }

    //#endregion
    // Scroll to error handler function
    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);

        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }

    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    closeDialog(){
        const nameCtrl = this.savedSearchDetailsForm.get('name');
        const desCtrl = this.savedSearchDetailsForm.get('description');
        nameCtrl?.enable();
        desCtrl?.enable();

        this.savedSearchAddViewEditHeader = "Add Saved Search";
        this.savedSearchEditId = 0;
        this.savedSearchDetails = null;
        this.savedSearchViewOnly = false;
        this.initSavedSearchDetailsForm();
        this.ruleData = [];
        this.ruleList = [];
        this.assocRuleList = [];
        if(this.activeUserTree.length>0){
            this.setSelectedUsers();
        }
        this.displayAddEditDialog = false;
        this.dialogClosed.emit(true);
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    changeAccountChannel(){
        if(this.ruleData.length>0){
            this.confirmationService.confirm({
                header: 'Delete Confirmation',
                message: 'Do you want to delete the Rules?',
                icon: 'pi pi-info-circle',
                accept: () => {
                    this.ruleData = [];
                    this.previousAccountChannel = this.savedSearchDetailsForm.get('selectedAccountChannel').value;
                },
                reject: () => {
                    this.savedSearchDetailsForm.controls['selectedAccountChannel'].patchValue(
                        this.previousAccountChannel
                    );
                }
            });
        }else{
            this.previousAccountChannel = this.savedSearchDetailsForm.get('selectedAccountChannel').value;
        }
    }
}
